import { CheckBoxInput } from 'src/components/Reusable/Inputs/CheckBox'
import styled from 'styled-components/macro'
import { AuditsSVG, ControlsSVG } from 'src/components/Icons/Basic'
import { GridColumn } from 'src/components/Reusable/Grid'
import palette from 'src/designSystem/variables/palette'

export const AuditBotCheckBox = styled(CheckBoxInput)`
  margin-left: 0.5rem;
`

export const AuditBotEmptyContainer = styled(GridColumn)`
  grid-column: 1 / -1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 2em;
  padding: 1.5em;
`

export const AuditBotEmptyTitle = styled.div`
  font-size: 1.75rem;
  display: flex;
  align-items: center;
  gap: 1rem;
`

export const AuditBotEmptyDescription = styled.div`
  font-size: 0.8rem;
`
export const AuditBotEmptyIcon = styled(AuditsSVG)`
  path {
    fill: ${palette.neutral[600]};
  }
  height: 2rem;
  margin-bottom: 0.25rem;
`
export const AuditBotControlsEmptyIcon = styled(ControlsSVG)`
  path {
    fill: ${palette.neutral[600]};
  }
  width: 2rem;
  height: 2rem;
`

export const AuditBotEmptyButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 1rem;
`

export const Line = styled.div`
  flex-grow: 1;
  height: 1px;
  background-color: ${palette.neutral[300]};
  margin: 0 10px;
`

export const LineContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  width: 100%;
`

export const LineP = styled.p`
  white-space: nowrap;
`

export const DateLimitInfoContainer = styled.div`
  margin-bottom: 1em;
`
